export default "__VITE_ASSET__DS40Fo5S__"